import React, { useState, useEffect } from 'react';
import debounceFunc from './debounceFunc';

const withScreenWidth = (WrappedComponent) => {
  const HOC = ({ ...props }) => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
      window.addEventListener('resize', () => {
        debounceFunc(setScreenWidth(window.innerWidth), 1000);
      });
    });

    return (
      <WrappedComponent
        screenWidth={screenWidth}
        {...props}
      />
    );
  };

  return HOC;
};

export default withScreenWidth;
